import { useInfiniteQuery } from "@tanstack/react-query";
import { GET_SMS_DELIVERY_LOGS_RESPONSE } from "../types/ResponseTypes";
import { fetcher } from "../../../utils/Axios";
import getNextPageParam from "../../../helpers/getNextPageParam";

export const GET_SMS_DELIVERY_LOGS_QUERY_KEY = "sms/delivery-logs?caseId";

async function getSmsDeliveryLogs(
  caseId?: string,
  page?: number
): Promise<GET_SMS_DELIVERY_LOGS_RESPONSE> {
  console.log("getSmsDeliveryLogs page --- ", page);
  const { data } = await fetcher({
    url: `sms/delivery-logs?caseId=${caseId}`,
  });

  return data;
}

function useGetSmsDeliveryLogsInfiniteQuery(caseId?: string) {
  return useInfiniteQuery({
    queryKey: [GET_SMS_DELIVERY_LOGS_QUERY_KEY, caseId],
    queryFn: ({ pageParam }) => getSmsDeliveryLogs(caseId, pageParam),
    getNextPageParam,
    initialPageParam: 1,
    enabled: !!caseId,
  });
}

export default useGetSmsDeliveryLogsInfiniteQuery;
